import {
    ChangeDetectionStrategy,
    Component,
    effect,
    ElementRef,
    input,
    viewChild,
    ViewEncapsulation,
} from "@angular/core";
import QRCode from "qrcode";
import { Proto } from "../pojo/Proto";
import HexColor = Proto.HexColor;

export namespace QR {
    export type ErrorCorrectionLevel = "low" | "medium" | "quartile" | "high" | "L" | "M" | "Q" | "H";
}

@Component({
    standalone: true,
    selector: "s25-ng-qr-code",
    template: ` <canvas #canvas></canvas> `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class S25QrCodeComponent {
    readonly text = input.required<string>();
    readonly scale = input<number>(1);
    readonly margin = input<number>(1);
    // Overrides scale
    readonly width = input<number>();
    readonly colorDark = input<HexColor>();
    readonly colorLight = input<HexColor>();
    readonly errorCorrectionLevel = input<QR.ErrorCorrectionLevel>();

    readonly canvas = viewChild("canvas", { read: ElementRef<HTMLCanvasElement> });

    private static readonly DEFAULT_SCALE = 4;
    private static readonly DEFAULT_MARGIN = 4;

    constructor() {
        effect((cleanUp) => {
            const canvas = this.canvas()?.nativeElement;
            const text = this.text();
            if (!canvas || !text) return;
            const scale = S25QrCodeComponent.DEFAULT_SCALE * (this.scale() || 1);
            const margin = S25QrCodeComponent.DEFAULT_MARGIN * (this.margin() ?? 1);
            const width = this.width();
            const color = { dark: this.colorDark(), light: this.colorLight() };
            const errorCorrectionLevel = this.errorCorrectionLevel();
            QRCode.toCanvas(canvas, text, { scale, margin, width, color, errorCorrectionLevel }, () => {});
        });
    }
}
